import { RootLayout } from './root-layout';

export { RootLayout };
